import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";

const SelectorSeccionConDNI = () => {
  const Usuario=ObtieneDatosCookies()
//   console.log(Usuario)
  const sedePorUsuario = () => {
  if (Usuario.sedeID == "2") return "Rosario";
  if (Usuario.sedeID == "3") return "Recreo";
  return "default"; // default para sedeID === 1
};

const [sede, setSede] = useState(sedePorUsuario);

  const [promocion, setPromocion] = useState("2025-2026");
  const [secciones, setSecciones] = useState([]);
  const [seccionId, setSeccionId] = useState("");
  const [dnisTexto, setDnisTexto] = useState("");
  const [loading, setLoading] = useState(false);

  const obtenerSecciones = async () => {
    try {
      const response = await axios.post(
        "https://wwwa.isepsantafe.net.ar/expedientes/devuelveSecciones"
      );

      const data = response.data || [];

      const companiasPorSede = {
        Rosario: [2, 3, 4],
        Recreo: [6, 7, 8],
      };

      const filtradas = data
        .filter(seccion =>
          companiasPorSede[sede].includes(seccion.companiaId)
        )
        .filter(seccion => {
          if (promocion === "2025-2026") return seccion.descripcion.includes("2do año");
          if (promocion === "2026-2027") return seccion.descripcion.includes("1er año");
          return true;
        });

      setSecciones(filtradas);
    } catch (error) {
      console.error("Error al obtener secciones", error);
    }
  };

  useEffect(() => {
    obtenerSecciones();
    setSeccionId("");
  }, [sede, promocion]);

  const enviarDatos = async () => {
    if (!seccionId) {
      Swal.fire("Atención", "Seleccioná una sección", "warning");
      return;
    }

    const dnis = dnisTexto
      .split(/\s|,|\n/)
      .map(d => d.trim())
      .filter(Boolean);

    if (dnis.length === 0) {
      Swal.fire("Atención", "Pegá al menos un DNI", "warning");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        "https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/asignarSeccionPorDni",
        { seccionId, dnis }
      );

      const { asignados, noAsignados, total } = response.data;

      let html = `<b>Total procesados:</b> ${total}<br><br>`;

      if (asignados?.length) {
        html += `<b style="color:#16a34a">Asignados (${asignados.length}):</b><br>`;
        asignados.forEach(a => (html += `✔️ DNI ${a.dni}<br>`));
        html += "<br>";
      }

      if (noAsignados?.length) {
        html += `<b style="color:#dc2626">No asignados (${noAsignados.length}):</b><br>`;
        noAsignados.forEach(n => (html += `❌ DNI ${n.dni} → ${n.motivo}<br>`));
      }

      Swal.fire({
        title: "Resultado de la asignación",
        html,
        icon: noAsignados?.length ? "warning" : "success",
        width: 600,
      });

      setDnisTexto("");
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Ocurrió un error al procesar", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* ===== ESTILOS INTERNOS ===== */}
      <style>{`
        .card {
          max-width: 720px;
          margin: 30px auto;
          padding: 24px;
          background: #fff;
          border-radius: 14px;
          box-shadow: 0 10px 30px rgba(0,0,0,.08);
          display: flex;
          flex-direction: column;
          gap: 18px;
          font-family: system-ui, sans-serif;
        }

        .card h3 {
          text-align: center;
          color: #1f2937;
        }

        .section {
          background: #f9fafb;
          padding: 14px;
          border-radius: 10px;
          display: flex;
          flex-direction: column;
          gap: 10px;
        }

        .label {
          font-weight: 600;
          font-size: 14px;
          color: #374151;
        }

        .buttons {
          display: flex;
          justify-content: center;
          gap: 10px;
        }

        .buttons button {
          padding: 8px 16px;
          border-radius: 8px;
          border: 1px solid #d1d5db;
          background: white;
          cursor: pointer;
        }

        .buttons button:disabled {
          background: #2563eb;
          color: white;
          border-color: #2563eb;
        }

        select, textarea {
          padding: 10px;
          border-radius: 8px;
          border: 1px solid #d1d5db;
          font-size: 14px;
        }

        textarea {
          min-height: 120px;
          resize: vertical;
          font-family: monospace;
        }

        .submit {
          background: #16a34a;
          color: white;
          border: none;
          padding: 12px;
          border-radius: 10px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
        }

        .submit:disabled {
          background: #9ca3af;
        }

        .helper {
          font-size: 12px;
          color: #6b7280;
          text-align: center;
        }
      `}</style>

      {/* ===== UI ===== */}
      <div className="card">
        <h3>Asignación de Cadetes a Sección</h3>

       <div className="section">
  <span className="label">Sede</span>
  <div className="buttons">
    {Usuario.sedeID == 1 && (
      <>
        <button
          onClick={() => setSede("Rosario")}
          disabled={sede === "Rosario"}
        >
          Rosario
        </button>
        <button
          onClick={() => setSede("Recreo")}
          disabled={sede === "Recreo"}
        >
          Recreo
        </button>
      </>
    )}

    {Usuario.sedeID == 2 && (
      <button disabled>Rosario</button>
    )}

    {Usuario.sedeID == 3 && (
      <button disabled>Recreo</button>
    )}
  </div>
</div>

        <div className="section">
          <span className="label">Promoción</span>
          <div className="buttons">
            <button onClick={() => setPromocion("2025-2026")} disabled={promocion === "2025-2026"}>2025–2026</button>
            <button onClick={() => setPromocion("2026-2027")} disabled={promocion === "2026-2027"}>2026–2027</button>
          </div>
        </div>

        <div className="section">
          <span className="label">Sección</span>
          <select value={seccionId} onChange={e => setSeccionId(e.target.value)}>
            <option value="">Seleccioná una sección</option>
            {secciones.map(s => (
              <option key={s.id} value={s.id}>
                {s.Compania?.nombre} – {s.descripcion} – {s.nombre}
              </option>
            ))}
          </select>
        </div>

        <div className="section">
          <span className="label">DNIs</span>
          <textarea
            placeholder="Uno por línea, coma o espacio"
            value={dnisTexto}
            onChange={e => setDnisTexto(e.target.value)}
          />
          <div className="helper">Ej: 40123456, 39876543</div>
        </div>

        <button className="submit" onClick={enviarDatos} disabled={loading}>
          {loading ? "Procesando..." : "Asignar Sección"}
        </button>

       
      </div>
    </>
  );
};

export default SelectorSeccionConDNI;
